
import { Button, EditableText, FormGroup, H2, Intent } from "@blueprintjs/core";
import { generateSchema } from "decorator-form";
import { ISchema } from 'decorator-form/dist/generate';
import React from "react";
import Form, { FormProps } from "react-jsonschema-form";
import { connect } from "react-redux";
import { Registry } from "react-registry";
import { bindActionCreators } from "redux";
import styled from 'styled-components';

import * as configActions from "core/actions/configActions";
import { CONFIG_DEFAULT } from "core/decorators/View";
import initialState from "core/reducers/initialState";
import Class from 'core/util/Class';

export enum ConfigFormType {
	PANEL = "panels",
	VIEW = "views"
}

export interface IConfigFormProps {
	type: ConfigFormType;
	id?: string;
	instance?: string;
	actions?;
	data?: any;
	schema?: ISchema;
}

const FormCont = styled.div`
	background: rgb(48,64,78,.85);
    padding: 15px;
    border-radius: 4px;
`;

export const EDIT_NAME = "editName";

class ConfigForm extends React.Component<IConfigFormProps> {

	public render() {
		const { schema } = this.props;

		return (
			<div>
				{ConfigFormType.VIEW === this.props.type && (
					<div key="general">
						<H2>
							{
								CONFIG_DEFAULT === this.props.instance ? "Default Configuration" : (
									<EditableText
										defaultValue={this.props.data ? this.props.data[EDIT_NAME] : undefined}
										onConfirm={this.onFieldChange(EDIT_NAME)}
										placeholder="Edit Name"
									/>
								)
							}
						</H2>
					</div>
				)}
				<FormCont className={"config-form"}>
					<Form
						schema={schema.schema}
						uiSchema={schema.uiSchema}
						fields={schema.fields}
						onChange={this.onFormChange}
						formData={this.props.data}
					>
						<div />
					</Form>
				</FormCont>
				<div key="actions">
					{ConfigFormType.VIEW === this.props.type && (
						<FormGroup>
							<Button
								intent={Intent.DANGER}
								minimal={true}
								onClick={this.resetConfig}
								text="Reset Configuration"
							/>
						</FormGroup>
					)}
				</div>
			</div>
		);
	}

	private onFormChange = (form: FormProps<any>) => {
		this.emitOnChange(form.formData);
	}

	private onFieldChange = (field: string) => (value: any) => {
		this.emitOnChange({...this.props.data || {}, [field]: value});
	}

	private emitOnChange = (data: any) => {
		switch(this.props.type) {
			case ConfigFormType.VIEW:
				this.props.actions.configViewAdd(this.props.id, this.props.instance, data);
				break;
			case ConfigFormType.PANEL:
				this.props.actions.configPanelAdd(this.props.instance, data);
				break;
		}
	}

	private resetConfig = () => {
		this.emitOnChange({});
	}
}

function getDataFromState(state: any, type: ConfigFormType, id: string, instance: string) {
	switch(type) {
		case ConfigFormType.PANEL:

			return state.config[ConfigFormType.PANEL][instance];

		case ConfigFormType.VIEW:

			return state.config[ConfigFormType.VIEW][id] && state.config[ConfigFormType.VIEW][id][instance];

		default:
			return undefined;
	}
}

function mapConfig(state = initialState, ownProps: IConfigFormProps) {
	const data = getDataFromState(state, ownProps.type, ownProps.id, ownProps.instance);

	const id = ConfigFormType.PANEL === ownProps.type ? data.id : ownProps.id;
	const config = Registry.get({id, registry: ConfigFormType.PANEL === ownProps.type ? "panels:config" : "views:config"}) as Class<any>;

	return {
		data: {...!data ? new config() : data}, // copy so we dont mutate the acutal store
		schema: generateSchema(config)
	};
}

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect(mapConfig, mapDispatchToProps)(ConfigForm as any);



// WEBPACK FOOTER //
// ./src/core/components/editor/ConfigForm.tsx